<template>
	<div class="container">
		<!-- Loading State -->
		<div v-if="is_first_loading" class="card shadow-sm text-center p-4">
			<b-spinner variant="warning" class="mb-3 mx-auto" />
			<p class="text-secondary">Memuat data, mohon tunggu...</p>
		</div>

		<!-- Main UI -->
		<div v-else>
			<!-- CERTIFICATE STATUS -->
			<b-card no-body class="mb-2">
				<b-card-header header-tag="header" class="p-3" role="tab">
					<span class="m-1">Status Sertifikat EKYC</span>
					<b-button v-b-toggle.accordion-certificate variant="yellow" class="chevron">
						<span class="when-open"><b-icon icon="chevron-up" /></span>
						<span class="when-closed"><b-icon icon="chevron-down" /></span>
					</b-button>
				</b-card-header>

				<b-collapse id="accordion-certificate" accordion="kyc-sign-accordion" role="tabpanel">
					<b-card-body>
						<b-card-text>
							<div class="container">
								<p class="h5 d-flex align-items-center mb-0">
									<strong class="mr-2">Status Sertifikat:</strong>
									<i :class="['fas', certificateFaIcon, certificateFaColor, 'mr-2']" style="font-size: 1.3rem;" />
									{{ certificateStatusText }}
								</p>

								<!-- Tombol Hapus Sertifikat -->
								<b-button
									variant="danger"
									class="mt-3"
									@click="showRevokeModal = true"
                  v-if="cer_status === 3"
								>
									Hapus Sertifikat
								</b-button>
							</div>
						</b-card-text>
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- Modal Revoke -->
			<b-modal
				v-model="showRevokeModal"
				title="Hapus Sertifikat e-KYC"
				hide-footer
				centered
			>
				<b-form-group label="Pilih Alasan Penghapusan Sertifikat:">
					<b-form-select
						v-model="selectedRevokeReason"
						:options="reasonList"
						:disabled="reasonList.length === 0"
						placeholder="Pilih alasan..."
					/>
				</b-form-group>

				<div class="text-right">
					<b-button
            variant="primary"
            class="mt-2"
            :disabled="is_loading"
            @click="submitRevoke"
          >
            <b-spinner
              v-if="is_loading"
              small
              type="border"
              class="mr-2"
            />
            {{ is_loading ? "Memproses..." : "Lanjutkan" }}
          </b-button>
				</div>
			</b-modal>

      <!-- Re-Enroll Sertifikat -->
      <b-card
        v-if="is_revoke_request && cer_status === 0"
        no-body
        class="mb-2"
      >
        <b-card-header header-tag="header" class="p-3" role="tab">
          <span class="m-1">Aktivasi Ulang Sertifikat e-KYC</span>
        </b-card-header>

        <b-card-body>
          <p>
            Anda telah mengajukan penghapusan sertifikat. Silakan klik tombol di bawah untuk melakukan aktivasi ulang.
          </p>
          <b-button
            variant="primary"
            :disabled="is_loading"
            @click="reenrollCertificate"
          >
            <b-spinner small class="mr-2" v-if="is_loading" />
            {{ is_loading ? 'Mengalihkan...' : 'Aktivasi Ulang Sertifikat' }}
          </b-button>
        </b-card-body>
      </b-card>

			<!-- GANTI MFA -->
			<b-card no-body class="mb-2">
				<b-card-header header-tag="header" class="p-3" role="tab">
					<span class="m-1">Ganti Metode MFA</span>
					<b-button v-b-toggle.accordion-mfa variant="yellow" class="chevron">
						<span class="when-open"><b-icon icon="chevron-up" /></span>
						<span class="when-closed"><b-icon icon="chevron-down" /></span>
					</b-button>
				</b-card-header>

				<b-collapse id="accordion-mfa" accordion="kyc-sign-accordion" role="tabpanel">
					<b-card-body>
						<b-card-text>
							<div class="container text-center">
								<b-button variant="primary" class="mt-2 w-100" @click="handleMfaSetup">
									{{ is_loading ? 'Memuat halaman MFA...' : 'Ganti / Atur MFA' }}
								</b-button>
                <span>MFA = Multi Factor Authentication</span>
							</div>
						</b-card-text>
					</b-card-body>
				</b-collapse>
			</b-card>

      <!-- GANTI Signature -->
			<b-card no-body class="mb-2">
				<b-card-header header-tag="header" class="p-3" role="tab">
					<span class="m-1">Ganti Tanda Tangan</span>
					<b-button v-b-toggle.accordion-signature variant="yellow" class="chevron">
						<span class="when-open"><b-icon icon="chevron-up" /></span>
						<span class="when-closed"><b-icon icon="chevron-down" /></span>
					</b-button>
				</b-card-header>

				<b-collapse id="accordion-signature" accordion="kyc-sign-accordion" role="tabpanel">
					<b-card-body>
						<b-card-text>
							<div class="container text-center">
								<b-button variant="primary" class="mt-2 w-100" @click="handleSignatureSetup">
									{{ is_loading ? 'Memuat halaman Tanda Tangan...' : 'Ganti / Atur Tanda Tangan' }}
								</b-button>
							</div>
						</b-card-text>
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- Iframe Pop-up -->
      <div v-if="showIframe" class="popup-overlay">
        <div class="popup-content">
          <!-- Tombol Tutup -->
          <button @click="closeIframe" class="close-btn" :disabled="is_loading">
            <span v-if="is_loading">
              <b-spinner small variant="light" class="mr-2" />
              Menutup...
            </span>
            <span v-else>
              Tutup
            </span>
          </button>

          <!-- Iframe -->
          <iframe :src="iframeUrl" allow="camera; microphone" frameborder="0"></iframe>
        </div> 
      </div>
		</div>
	</div>
</template>

<script>
import Funder from "../../api/funder";
import KycFunder from "@/api/kycfunder";
import DataRevokeReason from "@/api/DataRevokeReason";
import AuthMe from "../../api/user"

export default {
  name: "KycSign",
  data() {
    return {
      is_first_loading: true,
      is_loading: false,
      kycStatus: "Pending",
      request_id: null,
      username: null,
      cer_status: null,
      is_revoke_request: false,
      revoke_reason_id: null,
      revoke_url: null,
      currentMfa: "Email",
      iframeUrl: "",
      showIframe: false,
      showRevokeModal: false,
      selectedRevokeReason: null,
      reasonList: [],
    };
  },
  computed: {
    certificateStatusText() {
      const statuses = {
        0: "Tidak ada sertifikat",
        1: "Sedang diverifikasi",
        2: "Menunggu Konfirmasi",
        3: "Aktif",
        4: "Ditolak",
      };
      return statuses[this.cer_status] || "Status e-KYC tidak diketahui";
    },
    certificateFaIcon() {
			switch (this.cer_status) {
				case 3: return 'fa-shield-alt';
				case 2: return 'fa-hourglass-half';
				case 4: return 'fa-times-circle';
				case 1: return 'fa-clock';
				default: return 'fa-question-circle';
			}
		},
		certificateFaColor() {
			switch (this.cer_status) {
				case 3: return 'text-success';
				case 2: return 'text-warning';
				case 4: return 'text-danger';
				default: return 'text-secondary';
			}
		}
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      try {
        const response = await Funder.show(this.$store.state.auth.user.info.id);
        const authMe = await AuthMe.show();
        if (authMe.data.meta.code === 200) {
          const userData = response.data.data;
          this.request_id = authMe.data.data.user_tilaka.request_id;
          this.username = authMe.data.data.user_tilaka.username;
          this.cer_status = authMe.data.data.user_tilaka.cer_status;
          this.is_revoke_request = authMe.data.data.user_tilaka.is_revoke_request;
          this.revoke_reason_id = authMe.data.data.user_tilaka.revoke_reason_id;
          this.revoke_url = authMe.data.data.user_tilaka.revoke_url;

          if (this.cer_status === 3) {
            await this.loadRevokeReasons();
          }
        } else {
          this.showToast(response.data.meta.message || "Gagal memuat data nasabah.", "Kesalahan", "danger");
        }
      } catch (error) {
        console.log("error  : ", error);
        this.showToast("Terjadi kesalahan saat memuat data nasabah.", "Kesalahan", "danger");
      } finally {
        this.is_first_loading = false;
      }
    },
    async loadRevokeReasons() {
      try {
        const response = await DataRevokeReason.index();
        if (response.data.meta.code === 200) {
          this.reasonList = response.data.data.map(item => ({
            value: item.id,
            text: item.reason,
          }));
        } else {
          this.showToast("Gagal memuat alasan penghapusan sertifikat.", "Error", "danger");
        }
      } catch (error) {
        this.showToast("Terjadi kesalahan saat mengambil alasan revoke.", "Error", "danger");
      }
    },
    async submitRevoke() {
			this.is_loading = true;
      try {
				if (!this.selectedRevokeReason) {
					this.showToast("Silakan pilih alasan penghapusan terlebih dahulu.", "Validasi", "warning");
					return;
				}
				
        const response = await KycFunder.revokeCertificate({ revoke_reason_id: this.selectedRevokeReason });
        if (response.data.meta.code === 200) {
          this.iframeUrl = response.data.data.revoke_url;
          this.showIframe = true;
        } else {
          this.showToast(response.data.meta.message || "Gagal memuat URL penghapusan sertifikat", "Kesalahan", "danger");
        }
      } catch (error) {
        this.showToast("Terjadi kesalahan saat mengambil URL penghapusan sertifikat", "Kesalahan", "danger");
      } finally {
        this.is_loading = false;
      }
    },
    async handleMfaSetup() {
      this.is_loading = true;
      try {
        const response = await KycFunder.getUrlWebviewGantiMFA({ redirect_url: null });
        if (response.data.meta.code === 200) {
          this.iframeUrl = response.data.data.url;
          this.showIframe = true;
        } else {
          this.showToast(response.data.meta.message || "Gagal memuat URL MFA", "Kesalahan", "danger");
        }
      } catch (error) {
        this.showToast("Terjadi kesalahan saat mengambil URL MFA", "Kesalahan", "danger");
      } finally {
        this.is_loading = false;
      }
    },
    async handleSignatureSetup() {
      this.is_loading = true;
      try {
        const response = await KycFunder.getUrlWebviewGantiSignature({ redirect_url: null });
        if (response.data.meta.code === 200) {
          this.iframeUrl = response.data.data.url;
          this.showIframe = true;
        } else {
          this.showToast(response.data.meta.message || "Gagal memuat URL Tanda Tangan", "Kesalahan", "danger");
        }
      } catch (error) {
        this.showToast("Terjadi kesalahan saat mengambil URL Tanda Tangan", "Kesalahan", "danger");
      } finally {
        this.is_loading = false;
      }
    },
    async reenrollCertificate() {
      this.is_loading = true;
      try {
        const registerResponse = await KycFunder.registerReEnroll();
        if (registerResponse.data.meta.code == 200) {
          this.registered_id = registerResponse.data.data[0];
          this.showToast(registerResponse.data.meta.message ? registerResponse.data.meta.message : 'Registrasi berhasil.', "Sukses", "success");
          this.$router.push('/ekyc-funder/re-enroll/register');
          // todo: redirect ke halaman ini untuk melakukan webview registrasi,
        } else {
          this.showToast(registerResponse.data.meta.message ? registerResponse.data.meta.message : 'Registrasi gagal. Silakan coba lagi.', "Kesalahan", "danger");
        }
      } catch (error) {
        this.showToast("Terjadi kesalahan saat melakukan aktivasi ulang sertifikat e-KYC.", "Kesalahan", "danger");
      } finally {
        this.is_loading = false;
      }
    },
    async closeIframe() {
      this.is_loading = true;

      try {
        const response = await KycFunder.redirectPenautanKYC({ 
          request_id: this.request_id,
          tilaka_name: this.username,
        });

        if (response.data.meta.code !== 200) {
          const errorMessage = response.data.meta.message || "Terjadi kesalahan.";
          this.showToast(errorMessage, "Kesalahan", "danger");
        }
      } catch (error) {
        this.showToast("Terjadi kesalahan saat menghubungi server.", "Kesalahan", "danger");
      } finally {
        this.is_loading = false;
        this.showIframe = false;
        location.reload();
      }
    },
    showToast(message, title, variant = "default") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background: white;
  width: 90%;
  height: 90%;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.popup-content iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 5px;
  z-index: 10;
}

.close-btn:hover {
  background: darkred;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/KycSign.vue